<script setup lang="ts">
import { useCartStore } from '../stores/cart';
import CartItem from './CartItem.vue';

const cart = useCartStore();
</script>

<template>
    <ul v-if="(cart.cart?.lineItems ?? []).length > 0" class="list-unstyled">
        <CartItem
            v-for="item in cart.cart?.lineItems ?? []"
            :key="item.id"
            :item="item"
        />
    </ul>
</template>
